import React from 'react';

/**
 * OFTabs — Tabs de OFs com design Samidel
 * Verde escuro activo, fundo claro inactivo
 */
export default function OFTabs({ activeTab, onChange, counts = {} }) {
  const tabs = [
    { id: 'novas', label: 'Novas', count: counts.novas || 0 },
    { id: 'iniciadas', label: 'Iniciadas', count: counts.iniciadas || 0 },
    { id: 'terminadas', label: 'Terminadas', count: counts.terminadas || 0 },
  ];

  return (
    <div
      className="flex gap-1 p-1 rounded-2xl"
      style={{ background: '#E2E8F0' }}
    >
      {tabs.map(tab => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            className="flex-1 flex items-center justify-center gap-1.5 py-2.5 rounded-xl transition-all"
            style={{
              background: isActive ? '#0B3B30' : 'transparent',
              color: isActive ? '#FFFFFF' : '#64748B',
            }}
            data-testid={`tab-${tab.id}`}
          >
            <span className="text-sm font-extrabold">{tab.label}</span>
            {tab.count > 0 && (
              <span
                className="text-[10px] font-black px-1.5 py-0.5 rounded-full"
                style={{
                  background: isActive ? 'rgba(255,255,255,0.25)' : '#CBD5E1',
                  color: isActive ? '#FFFFFF' : '#475569',
                }}
              >
                {tab.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
